module.exports = __webpack_public_path__ + "static/img/akum_800_40.6a96307.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_40.svg
// module id = Rh8K
// module chunks = 1